import {
  IFavoriteOriginPricesResponse,
  IFavoriteOriginWithMonths,
  IFavoriteResponse,
} from "../types/IFavoriteOrigins";

const parseDateToParts = (value: string | undefined) => {
  const raw = String(value || "");
  const match = raw.match(/(\d{4})-(\d{2})-(\d{2})/);
  if (!match) {
    return { year: 1900, month: 1, day: 1 };
  }

  return {
    year: Number(match[1]),
    month: Number(match[2]),
    day: Number(match[3]),
  };
};

export const mapFavoritesByMarketerToLegacy = (
  favoritesByMarketer: IFavoriteResponse[],
): IFavoriteOriginPricesResponse[] => {
  const productMap = new Map<string, IFavoriteOriginWithMonths[]>();

  favoritesByMarketer.forEach((entry) => {
    (entry.favoriteSets || []).forEach((favoriteSet) => {
      const existingRows = productMap.get(favoriteSet.product) || [];

      const nextRows = (favoriteSet.favoriteLocations || []).map(
        (favoriteLocation, index) => {
          const months = (favoriteLocation.months || []).map((month) => {
            const periods = [month.firstPeriod, month.secondPeriod]
              .filter(Boolean)
              .map((period) => {
                const sortedInfos = [...(period!.infos || [])].sort(
                  (a, b) => a.order - b.order,
                );

                const additionalTypes = sortedInfos.map((info) => {
                  const parsedValue = Number(info.value);
                  return {
                    name: info.name,
                    price: Number.isFinite(parsedValue) ? parsedValue : null,
                    showAs: null,
                    value: info.value,
                    order: info.order,
                  };
                });

                return {
                  id: period!.id,
                  startDate: parseDateToParts(period!.startDate),
                  endDate: parseDateToParts(period!.endDate),
                  prices: {
                    posted: period!.posted
                      ? {
                          id: period!.posted.id,
                          price: period!.posted.price,
                          showAs: period!.posted.showAs,
                          requestedAt: period!.posted.updatedAt,
                          requestedBy: period!.posted.updatedBy,
                        }
                      : null,
                    truck: period!.truck
                      ? {
                          id: period!.truck.id,
                          price: period!.truck.price,
                          showAs: period!.truck.showAs,
                          requestedAt: period!.truck.updatedAt,
                          requestedBy: period!.truck.updatedBy,
                        }
                      : null,
                    rail: period!.rail
                      ? {
                          id: period!.rail.id,
                          price: period!.rail.price,
                          showAs: period!.rail.showAs,
                          requestedAt: period!.rail.updatedAt,
                          requestedBy: period!.rail.updatedBy,
                        }
                      : null,
                    additionalTypes,
                  },
                };
              });

            return {
              id: month.id,
              month: parseDateToParts(month.month),
              isSplit: Boolean(month.split),
              periods,
            };
          });

          return {
            id: favoriteLocation.id,
            competitor: favoriteLocation.competitor,
            location: {
              id: favoriteLocation.location.id,
              name: favoriteLocation.location.name,
              outboundModes: favoriteLocation.location.outboundModes || [],
            },
            order: index,
            months,
          } as IFavoriteOriginWithMonths;
        },
      );

      productMap.set(favoriteSet.product, [...existingRows, ...nextRows]);
    });
  });

  return Array.from(productMap.entries()).map(([product, favorites]) => ({
    product,
    favorites,
  }));
};
